import React, { Suspense, useState, useEffect } from 'react';
import SuspenseComponent from '../../../views/components/SuspenseComponent';
import DeviceBreadcrumbComponent from '../DeviceBreadcrumbComponent';
import DeviceLogsTable from './DeviceLogsTable';
import DeviceLogsSubmitDateRange from './DeviceLogsSubmitDateRange';
import { useParams, useLocation } from "react-router-dom";
import { getDeviceLogsByRange, getDeviceFailsByRange } from "API";
import { useMutation, useQueryClient, } from 'react-query'
import { Row, Col } from "reactstrap";
import useSerialCheck from 'hooks/useSerialCheck';
import { useDataDeviceAccess } from 'contexts/DataDeviceContext';
import DeviceLogsFailsDoughnut from './DeviceLogsFailsDoughnut';
import moment from 'moment';
const DeviceLogs = (props) => {
    let { serial } = useParams();
    const location = useLocation();
    const timestamp = location.state?.timestamp;
    const userDataDeviceAccess = useDataDeviceAccess();
    const serialFound = useSerialCheck(userDataDeviceAccess, serial);
    const [valueDateRange, setValueDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]);

    useEffect(() => {
        if (timestamp !== undefined) {
            setValueDateRange([ new Date(timestamp), new Date(timestamp)])
            setLoading(true);
            const dateStart = moment(timestamp).startOf('day').toDate();
            const dateEnd= moment(timestamp).endOf('day').toDate();
            let startRange = new Date(dateStart);
            let endRange = new Date(dateEnd);
            mutationLogs({ serial: serial, startRange: startRange, endRange: endRange})
            mutationFails({ serial: serial, startRange: startRange, endRange: endRange})
        }
    }, [timestamp])

    const [loading, setLoading] = useState(null);
    const queryClient = useQueryClient()
    const handleSubmit = () => {
        if (valueDateRange !== null) {
            if (valueDateRange[0] instanceof Date && valueDateRange[1] instanceof Date) {
                setLoading(true);
                mutationLogs({ serial: serial, startRange: valueDateRange[0], endRange: valueDateRange[1] });
                mutationFails({ serial: serial, startRange: valueDateRange[0], endRange: valueDateRange[1] });
            }
        }
    }

    const { mutate: mutationLogs } = useMutation(
        {
            mutationFn: getDeviceLogsByRange,
            onSuccess: async (newData) => {
                setLoading(false);
                queryClient.setQueryData("Logs", newData);
            }
        }
    );

    const { mutate: mutationFails } = useMutation(
        {
            mutationFn: getDeviceFailsByRange,
            onSuccess: async (newData) => {
                setLoading(false);
                queryClient.setQueryData("Fails", newData);
            }
        }
    );

    return (
        <>
            <div className="content">
                <Row>
                    <Col lg="3">
                        <h4>
                            {serialFound !== true ? null : `${serial} Logs`}
                        </h4>
                    </Col>
                    <Col lg="9">
                        <DeviceBreadcrumbComponent activePath={'DeviceLogs'} serial={serial} />
                    </Col>
                </Row>
                <Row>
                    <Col lg="3" className='d-flex'>
                        <DeviceLogsSubmitDateRange valueDateRange={valueDateRange} setValueDateRange={setValueDateRange} handleSubmit={handleSubmit} />
                    </Col>
                    <Col lg="9" className='d-flex'>
                        <Suspense fallback={<SuspenseComponent />}>
                            <DeviceLogsFailsDoughnut loading={loading} serial={serial} valueDateRange={valueDateRange} />
                        </Suspense>
                    </Col>
                </Row>
                <Suspense fallback={<SuspenseComponent />}>
                    <DeviceLogsTable loading={loading} serial={serial} valueDateRange={valueDateRange} />
                </Suspense>
            </div>
        </>
    );
};

export default DeviceLogs;
